import React from 'react';
const Iframe = props => {
    const { customStyle, source, title } = props;
    return <iframe src={source} style={customStyle} title={title}/>;
};
Iframe.defaultProps = {
    customStyle: {},
};
export default Iframe;
